import { inject, Injectable } from '@angular/core';
import { IAsn660ApiService } from './asn660-api.interface';
import { map, Observable } from 'rxjs';
import { Asn660, ShippingNotice, Vehicle } from '../domain/asn660.model';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseApi } from '@domain/shared/infrastructure/models/response-api.interface';
import {
  mapAllAsn660s,
  mapAsn660,
  mapShippingNotice,
  mapVehicles,
} from '../mappers/asn660.mappert';
import {
  ASN660ApiModel,
  ShippingNoticeApiModel,
  VehicleApiModel,
} from './asn660-api.model';

@Injectable({
  providedIn: 'root',
})
export class Asn660ApiService implements IAsn660ApiService {
  private readonly _baseUrl = environment.baseUrl;
  private _httpClient = inject(HttpClient);

  getAllAsn660(): Observable<Asn660[]> {
    const url = `${this._baseUrl}asn660`;
    const headers = new HttpHeaders();
    return this._httpClient
      .get<ResponseApi>(url, { headers })
      .pipe(map((r) => mapAllAsn660s(r.results as ASN660ApiModel[])));
  }

  getAsn660ById(id: number): Observable<Asn660> {
    const url = `${this._baseUrl}asn660/${id}`;
    const headers = new HttpHeaders();
    return this._httpClient
      .get<ResponseApi>(url, { headers })
      .pipe(map((r) => mapAsn660(r.results as ASN660ApiModel)));
  }

  getVinsByShippingNotice(shippingNoticeId: number): Observable<Vehicle[]> {
    const url = `${this._baseUrl}asn660/shipping-notice/${shippingNoticeId}/vehicles`;
    const headers = new HttpHeaders();
    return this._httpClient.get<ResponseApi>(url, { headers }).pipe(
      map((r) => {
        if (!r.results) return [];
        if (Array.isArray(r.results) && r.results.length == 0) return [];

        return mapVehicles(r.results as VehicleApiModel[]);
      })
    );
  }

  getShippingNotices(params?: {
    isUsed?: boolean;
    isUsedDownload?: boolean;
  }): Observable<ShippingNotice[]> {
    const { isUsed, isUsedDownload } = params || {};
    const url = `${this._baseUrl}shipping-notices?isUsed=${
      isUsed || false
    }&isUsedDownload=${isUsedDownload || false}`;
    const headers = new HttpHeaders();
    return this._httpClient.get<ResponseApi>(url, { headers, params }).pipe(
      map((r) => {
        if (!r.results) return [];
        if (Array.isArray(r.results) && r.results.length == 0) return [];

        const shippingNotices = r.results as ShippingNoticeApiModel[];

        return shippingNotices.map(mapShippingNotice);
      })
    );
  }
}
